<!-- Mobile View -->
<!-- <div class = "content-mobile">
    <div class = "header-mobile">
        <img  class ="imageR360 " src="../../../assets/images/r360.svg" alt="logo r360" width="104">
    </div>
    <div class = "principal-text-mobile">
        Realiza el seguimiento de tus entregas desde tu celular
    </div>
    <div class = "secondary-text-mobile">
         <p>  Para una mejor experiencia, descarga la aplicación móvil.
        Búscala como
        <span class="text-green">Ransa 360.</span>
    </p> 
    </div>
    <div class = "logos-mobile">
        <a href="https://play.google.com/store/apps/details?id=com.ransa.ransa360&hl=es_PE&gl=US"><img
            class="image-mobile-logo" 
                src="../../../../assets/images/Google-Play.png" alt="logo android"></a>
        <a href="https://apps.apple.com/ni/app/ransa-360/id1527683710"><img
                 class="image-mobile-logo"
                src="../../../../assets/images/App-store.png" alt="logo apple"></a>
    </div>
    <div class = "footer-mobile">
        <img class="image-mobile-footer" src="../../../../assets/images/Ransa.png" alt="logo ransa">
    </div>
</div> -->

<!-- Desktop View -->

    <form [formGroup]="formUser" class= "ocultar-mobile" *ngIf="!warning">
        <h2 class="margin">¡Te damos la bienvenida!</h2>
        <mat-form-field [hideRequiredMarker]="hideRequiredControl">
            <input matInput type="email" formControlName="username" autocomplete="email" required>
            <mat-label>Correo de usuario</mat-label>
            <mat-error *ngIf="!emailInput.valid">
                {{getEmailInputError()}}
            </mat-error>
        </mat-form-field>
        <mat-form-field [hideRequiredMarker]="hideRequiredControl">
            <input matInput placeholder="Password" [type]="hide ? 'password' : 'text'" formControlName="password"
                required>
            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-label>Contraseña</mat-label>
            <mat-error *ngIf="!passwordInput.valid">
                {{getPasswordInputError()}}
            </mat-error>
        </mat-form-field>
        <button mat-raised-button color="accent" (click)="singnIn()" [disabled]="!formUser.valid"
            *ngIf="!load; else sppin">
            Ingresar
        </button>
        <ng-template #sppin>
            <button class="sppin">
                <mat-spinner *ngIf="load" [diameter]="30"></mat-spinner>
            </button>
        </ng-template>
        <a routerLink="../forgot-pass">¿Olvidaste la contraseña?</a>
    </form>
    <form [formGroup]="formUser" class= "ocultar-mobile" *ngIf="warning">
        <h2 class="margin" style="text-align: center;"> Faltan {{daysUntilReset}} días para que su contraseña actual venza </h2>
        <button style="margin-bottom: 21px;" mat-raised-button color="accent" (click)="initiate()" [disabled]="!formUser.valid" 
            *ngIf="!load; else sppin">
            Continuar
        </button>
        <button mat-raised-button color="accent" (click)="changePass()" [disabled]="!formUser.valid"
            *ngIf="!loadChangePass; else sppin2">
            Cambiar de contraseña
        </button>
        <ng-template #sppin>
            <button class="sppin">
                <mat-spinner *ngIf="load" [diameter]="30"></mat-spinner>
            </button>
        </ng-template>
        <ng-template #sppin2>
            <button class="sppin2">
                <mat-spinner *ngIf="loadChangePass" [diameter]="30"></mat-spinner>
            </button>
        </ng-template>
    </form>
